import React from "react";
import NewUsers from "../../views/NewUsers";

const NewUsersPage = () => {
  return <NewUsers />;
};

export default NewUsersPage;
